import { t } from "@lingui/core/macro";
import type { GenericColorPickerSavedColorsState } from "./GenericColorPicker";

export type SavedColorsCloseConfirmationConfig = {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
};

export function requestSavedColorsClose({
  savedColorsState,
  onConfirmedClose,
  confirmUnsavedChanges,
}: {
  savedColorsState: GenericColorPickerSavedColorsState | null;
  onConfirmedClose: () => void;
  confirmUnsavedChanges: (config: SavedColorsCloseConfirmationConfig) => void;
}) {
  if (savedColorsState?.hasUnsavedChanges) {
    const title = t`Save color changes?`;
    const message = t`You have unsaved changes. Leaving edit mode now will discard them.`;
    const confirmLabel = t`Save`;
    const cancelLabel = t`Discard changes`;

    const handleDecision = async (confirmed: boolean) => {
      if (confirmed) {
        await savedColorsState.saveDraft();
      } else {
        savedColorsState.discardDraft();
      }

      onConfirmedClose();
    };

    confirmUnsavedChanges({
      title,
      message,
      confirmLabel,
      cancelLabel,
      onConfirm: () => {
        void handleDecision(true);
      },
      onCancel: () => {
        void handleDecision(false);
      },
    });
    return false;
  }

  onConfirmedClose();
  return true;
}
